import React from "react";
import { AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LoadError({ what, detail, onRetry, testid }: { what: string; detail?: string; onRetry: () => void; testid: string }) {
  return (
    <div role="alert" className="bg-card border border-destructive/40 rounded-xl p-5 space-y-3" data-testid={testid}>
      <p className="font-semibold flex items-center gap-2"><AlertTriangle className="h-4 w-4 text-destructive" />Couldn’t load {what}</p>
      <p className="text-sm text-muted-foreground">This is a loading problem, not an empty list. {detail}</p>
      <Button variant="outline" className="h-11" onClick={onRetry} data-testid={`${testid}-retry`}><RotateCw className="h-4 w-4 mr-2" />Retry</Button>
    </div>
  );
}
